import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { InputMaskModule } from 'primeng/inputmask';
import { MultiSelectModule } from 'primeng/multiselect';
import { TableModule } from 'primeng/table';
import { DriverRestrictionService } from '../../../driver/services/driver-restriction.service';
import { IncidentConfirmationModule } from '../../../driver/services/incident-confirmation/incident-confirmation.module';
import { NoteModule } from '../../../note/note.module';
import { ValidationResultsModule } from '../../../shared/components/validation-results/validation-results.module';
import { MVMSpinnerBtnModule } from '../../../shared/mvm-components/mvm-spinner-btn/mvm-spinner-btn.module';
import { SharedPipesModule } from '../../../shared/pipes/shared-pipes.module';
import { SharedValidatorsModule } from '../../../shared/validators/shared-validators.module';
import { MedicalReviewService } from '../../services/medical-review.service';
import { AdditionalRequirementsModalComponent } from '../additional-requirements/additional-requirements-modal.component';
import { AdditionalRequirementsComponent } from '../additional-requirements/additional-requirements.component';
import { CustomerMrpRestrictionModalComponent } from '../customer-mrp-restriction-modal/customer-mrp-restriction-modal.component';
import { CustomerMrpRestrictionsEditModalComponent } from '../customer-mrp-restrictions-edit-modal/customer-mrp-restrictions-edit-modal.component';
import { CustomerMrpRestrictionsComponent } from '../customer-mrp-restrictions/customer-mrp-restrictions.component';
import { DocumentModalModule } from '../document-modal/document-modal.module';
import { DocumentSelectModalModule } from '../document-select-modal/document-select-modal.module';
import { SelectConditionsComponent } from '../select-conditions/select-conditions.component';
import { MedicalExamCertificateHistoryComponent } from './medical-exam-certificate-history.component';
import { MedicalExamCertificateModalComponent } from './medical-exam-certificate-modal.component';
import { MedicalExamCertificateComponent } from './medical-exam-certificate.component';

@NgModule({
    declarations: [
        CustomerMrpRestrictionModalComponent,
        CustomerMrpRestrictionsComponent,
        MedicalExamCertificateComponent,
        MedicalExamCertificateHistoryComponent,
        MedicalExamCertificateModalComponent,
        SelectConditionsComponent,
        CustomerMrpRestrictionsEditModalComponent,
        AdditionalRequirementsComponent,
        AdditionalRequirementsModalComponent
    ],
    imports: [
        CalendarModule,
        CommonModule,
        FormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        IncidentConfirmationModule,
        InputMaskModule,
        MultiSelectModule,
        MVMSpinnerBtnModule,
        ReactiveFormsModule,
        SharedPipesModule,
        SharedValidatorsModule,
        TableModule,
        ValidationResultsModule,
        NoteModule,
        DocumentSelectModalModule,
        DocumentModalModule
    ],
    providers: [
        DriverRestrictionService,
        MedicalReviewService
    ],
    exports: [
        CustomerMrpRestrictionModalComponent,
        CustomerMrpRestrictionsComponent,
        MedicalExamCertificateComponent,
        MedicalExamCertificateHistoryComponent,
        MedicalExamCertificateModalComponent,
        SelectConditionsComponent,
        AdditionalRequirementsComponent,
        AdditionalRequirementsModalComponent
    ]
})
export class MedicalExamCertificateModule {
}
